import { SettlementRateActions, SettlementRateActionTypes } from './SettlementRateActions';
import { SettlementRate } from '../../model/SettlementRate';

export interface SettlementRateState {
  total: number;
  records: Array<SettlementRate>;
  message: string;
  status: string;
}

export const initialState: SettlementRateState = {
  total: 0,
  records: [],
  message: null,
  status: null
};

export function settlementRateReducer(state: SettlementRateState = initialState, action: SettlementRateActions):  SettlementRateState {
  switch (action.type) {
    case SettlementRateActionTypes.InitSettlementRates: {
      return {
        ...state,
        total: action.payload.total,
        records: action.payload.records.map(r => {
          return {
            ...r,
            price: Number(r.price)
          }
        }),
        message: action.payload.message,
        status: action.payload.status
      };
    }
  }
  return state;
}

export const initSettlementRateState = (state: SettlementRateState) => state;
